import { createFileRoute } from '@tanstack/react-router'
import OAuthRedirectPage from '@/components/pages/OAuthRedirectPage/OAuthRedirectPage'
import { z } from 'zod'

const oauthRedirectSearchSchema = z.object({
  state: z.string().optional(),
})

export const Route = createFileRoute('/login/redirect')({
  validateSearch: (search) => oauthRedirectSearchSchema.parse(search),
  component: RedirectRoute,
})

function RedirectRoute() {
  return <OAuthRedirectPage />
}
